import '@fullcalendar/core/vdom'; // for Vite
import { Calendar } from "@fullcalendar/core";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import axios from 'axios';



var getJSON = function(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'json';
    xhr.onload = function() {
        var status = xhr.status;
        if (status === 200) {
            callback(null, xhr.response);
        } else {
            callback(status, xhr.response);
        }
    };
    xhr.send();
};


function getMonth() {
    var date = $("#calendar").fullCalendar('getDate');
    var month_int = date.getMonth();
    console.log(month_int);
    //you now have the visible month as an integer from 0-11
}

var calendarEl = document.getElementById("calendar");

let calendar = new Calendar(calendarEl, {
    plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
    initialView: "dayGridMonth",
    aspectRatio: 1.4,
    headerToolbar: {
        left: "prev,next today",
        center: "title",
        right: "",
    },
    //dayMaxEvents: true,
    locale: "ja",

    // 日付をクリック、または範囲を選択したイベント
    selectable: true,
    select: function(info) {
        const consul = jQuery('#is_consul').attr('data-value');
        // alert(consul);
        //alert("selected " + info.startStr + " to " + info.endStr);
        if (consul == "True") {
            window.open('/consul/calendar/schedule/menu?ymd=' + info.startStr); // コンサルの場合
        } else {
            window.open('/consul/partner/select?ymd=' + info.startStr); // コンサル以外の場合
        }
        // 入力ダイアログ
        //const eventName = prompt("イベントを入力してください");
        /*if (eventName) {
            // イベントの追加
            calendar.addEvent({
                title: eventName,
                parson: agentName,
                start: info.start,
                end: info.end,
                allDay: true,
            });
        }*/
    },

    // 以下eventsをAPI: http://127.0.0.1:8000/api/calendar/list/202210 から取得できるようにし，月変更時に動的に変更できるような仕組みを作る


    events: function(info, successCallback, failureCallback) {
            let eventsArr = [];
            console.log(info.start);
            console.log(info.end);

            // URLを取得
            let url = new URL(window.location.href);

            // URLSearchParamsオブジェクトを取得
            let params = url.searchParams;
            let requestParams = '';
            params.forEach(function(value, key) {
                requestParams = requestParams + key + '=' + value + '&';
            });


            getJSON('/api/calendar/list/fetch-all?' + requestParams,
                function(err, data) {
                    if (err !== null) {
                        console.log('Something went wrong: ' + err);
                    } else {
                        for (var item in data.events) {
                            var new_array = { title: data.events[item].title, start: data.events[item].start, color: data.events[item].color };
                            eventsArr.push(new_array);
                        }
                        successCallback(eventsArr)
                    }
                });






            //successCallback(eventsArr)
        }
        //[{
        //         title: '山田' + '(￥1000/h)',
        //         start: '2022-09-03T13:00:00',
        //         color: '#5498B4' // 「予約可能な場合」　かつ　弁理士にとっては「自分のものではない予定」の色
        //     },
        //     {
        //         title: '田中' + '(￥2000/h)',
        //         start: '2022-10-04T11:00:00',
        //         color: '#c0c0c0' //弁理士側＆ユーザー側で　「既に予約が入っている」　かつ　「自分の予定ではない」場合の色
        //     },
        //     {
        //         title: '山田' + '(￥1000/h)',
        //         start: '2022-10-04T18:00:00',
        //         color: '#ffa500' //自分に関係のある予約がある場合の色(ユーザーの場合は申し込んだ。弁理士の場合は申し込まれた)
        //     },
        //     {
        //         title: '山田' + '(￥1000/h)',
        //         start: '2022-10-11T20:00:00',
        //         color: '#257e4a' //弁理士側で　「予約が入っていない」　かつ　「自分の予定である」場合の色
        //     },
        // ]


});
calendar.render();
